import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSite } from '../data/SiteContext';

export default function Experiences() {
  const navigate = useNavigate();
  const { events } = useSite();
  const EVENTS = events.filter(e => e.isActive);
  return (
    <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
      <div className="kicker">Experiences & Events</div>
      <h1 className="page-h1">Be there when it happens.</h1>
      <p className="page-sub" style={{ maxWidth:600 }}>Tickets, transfers and the right hotel for the world's best events — booked as one trip.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:20 }}>
        {EVENTS.map(e => (
          <div key={e.key} className="lift" onClick={() => navigate('/experiences/' + e.key)}
            style={{ cursor:'pointer', position:'relative', borderRadius:20, overflow:'hidden', minHeight:230, display:'flex', flexDirection:'column', justifyContent:'flex-end', boxShadow:'0 12px 28px rgba(16,90,90,0.14)' }}>
            <div className="cover bgimg" style={{ backgroundImage:`url(${e.img})` }}></div>
            <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0) 32%,rgba(6,40,45,0.86) 100%)' }}></div>
            <div style={{ position:'absolute', top:12, left:12, padding:'5px 11px', borderRadius:100, background:'#ffdd55', color:'#0c2b2f', fontSize:11, fontWeight:800 }}>{e.when}</div>
            <div style={{ position:'relative', padding:16, color:'#fff' }}>
              <div className="serif" style={{ fontSize:21, lineHeight:1.15 }}>{e.name}</div>
              <div style={{ fontSize:12.5, opacity:.88, marginTop:3 }}>{e.place}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ExperienceDetail() {
  const { key } = useParams();
  const navigate = useNavigate();
  const { contact, events, loading } = useSite();
  const EVENTS = events.filter(x => x.isActive);
  const e = EVENTS.find(x => x.key === key);

  if (!e) {
    return (
      <div className="wrap" style={{ paddingTop:80, paddingBottom:120, textAlign:'center', color:'#5a726f' }}>
        {loading ? 'Loading…' : <>We couldn't find that event. <Link to="/experiences" style={{ color:'#0e8a9c', fontWeight:700 }}>See all experiences</Link></>}
      </div>
    );
  }

  // The last line of every entry is the booking deadline — it earns its own callout.
  const paragraphs = (e.body || '').split('\n\n').filter(Boolean);
  const bookBy = paragraphs.at(-1)?.startsWith('Book by:') ? paragraphs.pop() : null;
  const others = EVENTS.filter(x => x.key !== e.key).slice(0, 4);
  const enquiry = `${contact.waLink}?text=${encodeURIComponent(`Hi! I'd like to plan a trip around ${e.name} (${e.place}, ${e.when}).`)}`;

  return (
    <div>
      <section style={{ position:'relative', minHeight:'clamp(320px,45vh,460px)', display:'flex', alignItems:'flex-end', overflow:'hidden' }}>
        <div className="cover"><div className="bgimg" style={{ backgroundImage:`url(${e.img})` }}></div></div>
        <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0.15),rgba(6,40,45,0.78))' }}></div>
        <div style={{ position:'relative', maxWidth:1240, margin:'0 auto', padding:'0 24px 40px', width:'100%', color:'#fff' }}>
          <span onClick={() => navigate('/experiences')} style={{ cursor:'pointer', color:'rgba(255,255,255,0.9)', fontWeight:700, fontSize:14 }}>← All experiences</span>
          <div style={{ display:'inline-block', margin:'14px 0 8px', padding:'6px 14px', borderRadius:100, background:'#ffdd55', color:'#0c2b2f', fontSize:12.5, fontWeight:800 }}>{e.when}</div>
          <h1 className="serif" style={{ fontSize:'clamp(30px,5vw,54px)', margin:0, letterSpacing:'-0.5px', lineHeight:1.1 }}>{e.name}</h1>
          <div style={{ fontSize:15, opacity:.92, marginTop:6 }}>{e.place}</div>
        </div>
      </section>

      <div style={{ maxWidth:1240, margin:'0 auto', padding:'40px 24px 72px', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:40 }}>
        <div>
          {paragraphs.map((p, i) => (
            <p key={i} style={{ fontSize:16.5, lineHeight:1.75, color:'#0c2b2f', margin:'0 0 16px' }}>{p}</p>
          ))}

          {others.length > 0 && (
            <>
              <h3 className="serif" style={{ fontSize:22, margin:'34px 0 14px' }}>More experiences</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:14 }}>
                {others.map(o => (
                  <Link key={o.key} to={'/experiences/' + o.key} className="lift"
                    style={{ position:'relative', borderRadius:16, overflow:'hidden', minHeight:120, display:'flex', alignItems:'flex-end', color:'#fff' }}>
                    <div className="cover bgimg" style={{ backgroundImage:`url(${o.img})` }}></div>
                    <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0) 30%,rgba(6,40,45,0.85) 100%)' }}></div>
                    <div style={{ position:'relative', padding:12 }}>
                      <div style={{ fontWeight:700, fontSize:14, lineHeight:1.25 }}>{o.name}</div>
                      <div style={{ fontSize:12, opacity:.85, marginTop:2 }}>{o.when}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>

        <div>
          <div className="card" style={{ position:'sticky', top:100, padding:26, borderRadius:24, boxShadow:'0 16px 40px rgba(16,90,90,0.14)' }}>
            {bookBy && (
              <div style={{ padding:'14px 16px', borderRadius:14, background:'rgba(255,221,85,0.22)', border:'1px solid rgba(169,118,26,0.25)', marginBottom:18 }}>
                <div style={{ fontSize:11.5, fontWeight:800, color:'#a9761a', textTransform:'uppercase', letterSpacing:'.06em' }}>Plan ahead</div>
                <div style={{ fontSize:14.5, marginTop:4, lineHeight:1.5, fontWeight:600 }}>{bookBy.replace(/^Book by:\s*/, '')}</div>
              </div>
            )}
            <div style={{ fontSize:13, color:'#5a726f', fontWeight:600 }}>When</div>
            <div style={{ fontWeight:800, fontSize:19, margin:'2px 0 12px' }}>{e.when}</div>
            <div style={{ fontSize:13, color:'#5a726f', fontWeight:600 }}>Where</div>
            <div style={{ fontWeight:800, fontSize:19, margin:'2px 0 18px' }}>{e.place}</div>

            <div style={{ fontSize:13.5, color:'#5a726f', lineHeight:1.6, paddingTop:16, borderTop:'1px solid rgba(14,138,122,0.12)', marginBottom:18 }}>
              We arrange the tickets, the hotel and the transfers as one booking, so nothing depends on a
              resale site or a stranger's confirmation email.
            </div>

            <a href={enquiry} target="_blank" rel="noreferrer" className="btn btn-green" style={{ display:'block', padding:15, boxShadow:'0 10px 22px rgba(18,153,76,0.35)' }}>Plan this trip on WhatsApp</a>
            <a href={contact.telLink} style={{ display:'block', textAlign:'center', marginTop:10, padding:13, borderRadius:14, fontWeight:700, color:'#0e8a9c', background:'rgba(14,138,122,0.1)' }}>Or call {contact.phone}</a>
          </div>
        </div>
      </div>
    </div>
  );
}
